import {Space} from "antd";
import {ServiceListHeader} from "./header";
import {ServiceListTable, ServiceListTableProps} from "./table";

type ServiceListProps = ServiceListTableProps & {
  isFetching: boolean;
};

export function ServiceList({
  currentPage,
  data,
  isLoading,
  isFetching,
  isPreviousData,
  paginationMeta,
  setCurrentPage,
}: ServiceListProps) {
  return (
    <Space size={24} direction="vertical" style={{display: "flex"}}>
      <Space size={24} direction="vertical" style={{display: "flex"}}>
        <ServiceListHeader />
        <ServiceListTable
          isPreviousData={isPreviousData}
          paginationMeta={paginationMeta}
          data={data}
          isLoading={isLoading || isFetching}
          setCurrentPage={setCurrentPage}
          currentPage={currentPage}
        />
      </Space>
    </Space>
  );
}
